<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.status === ""
        ? _c("b-card", { staticClass: "kyc-page-1 min-hight-80vh" })
        : _vm.status !== "SUBMITTED"
        ? _c(
            "b-card",
            { staticClass: "kyc-page-1 min-hight-80vh" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-start align-items-center mb-1",
                },
                [
                  _c("b-avatar", {
                    staticClass: "mr-1",
                    attrs: {
                      size: "56",
                      variant: "light-primary",
                      text: _vm.firstName,
                    },
                  }),
                  _c("div", { staticClass: "profile-user-info" }, [
                    _c("div", { staticClass: "user-name mb-0" }, [
                      _vm._v(_vm._s(_vm.$t("Kyc.Hi") + " " + _vm.userEmail)),
                    ]),
                  ]),
                ],
                1
              ),
              _vm.status !== "APPROVED"
                ? _c("div", { staticClass: "kyc-procress-info r-mt-30" }, [
                    _c("div", { staticClass: "kyc-col-1" }, [
                      _c("div", { staticClass: "title-page r-mt-8" }, [
                        _vm._v(" " + _vm._s(_vm.$t("Kyc.Get-Started")) + " "),
                      ]),
                      _c("div", { staticClass: "title-desc r-mt-22" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("Kyc.Security-Of-Your-Account")) +
                            " "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "kyc-col-1" },
                      [_c("VerificationI")],
                      1
                    ),
                  ])
                : _c("div", { staticClass: "kyc-procress-info r-mt-30" }, [
                    _c("div", { staticClass: "kyc-col-1" }, [
                      _c("div", { staticClass: "title-page r-mt-8" }, [
                        _vm._v(" " + _vm._s(_vm.$t("Kyc.KYCCompleted")) + " "),
                      ]),
                      _c("div", { staticClass: "title-desc r-mt-22" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("Kyc.KYCCompletedSub")) + " "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "kyc-col-1" },
                      [_c("VerificationI")],
                      1
                    ),
                  ]),
              _vm.status !== "APPROVED"
                ? _c("div", { staticClass: "kyc-procress-info r-mt-18" }, [
                    _c("div", { staticClass: "kyc-col-1" }, [
                      _c("div", { staticClass: "title-page r-mt-8" }, [
                        _vm._v(_vm._s(_vm.$t("Kyc.How-To-Complete"))),
                      ]),
                      _c("div", { staticClass: "title-desc r-mt-22" }, [
                        _c("div", [
                          _vm._v("1. " + _vm._s(_vm.$t("Kyc.KYC-Process-1"))),
                        ]),
                        _c("div", [
                          _vm._v("2. " + _vm._s(_vm.$t("Kyc.KYC-Process-2"))),
                        ]),
                        _c("div", [
                          _vm._v("3. " + _vm._s(_vm.$t("Kyc.KYC-Process-3"))),
                        ]),
                      ]),
                      _c("div", { staticClass: "privacy-text" }, [
                        _c("div", [
                          _vm._v(
                            " " + _vm._s(_vm.$t("Kyc.Your-Privacy")) + " "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(" " + _vm._s(_vm.$t("Kyc.Miss-Out")) + " "),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "kyc-col-1" },
                      [_c("VerificationII")],
                      1
                    ),
                  ])
                : _vm._e(),
              _c("Stepper", {
                key: _vm.updateState,
                attrs: { steps: _vm.steps },
              }),
              _vm.status !== "APPROVED"
                ? _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c(
                          "div",
                          { staticClass: "center-align-btn" },
                          [
                            _vm.status !== "DISAPPROVED"
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      to: {
                                        name: "personal-information",
                                        params: {
                                          lang: this.lang || undefined,
                                        },
                                      },
                                      variant: "primary",
                                      disabled: _vm.buttonDisabled,
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.disapprovedRemark,
                                expression: "disapprovedRemark",
                              },
                            ],
                            staticClass: "center-align-btn error-outer",
                          },
                          [
                            _c("Errors", {
                              attrs: { error: _vm.disapprovedRemark },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.status === "SUBMITTED"
        ? _c("b-card", [
            _c(
              "div",
              { staticClass: "under-review-page" },
              [
                _c(
                  "div",
                  { staticClass: "reload-page-btn" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-icon",
                        attrs: { variant: "flat-primary" },
                        on: { click: _vm.refreshKycStatus },
                      },
                      [
                        _c("feather-icon", { attrs: { icon: "RotateCwIcon" } }),
                        _c("span", { staticClass: "align-middle ml-1" }, [
                          _vm._v(_vm._s(_vm.$t("Kyc.Refresh"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("UnderReview"),
                _c("div", { staticClass: "under-review-txt" }, [
                  _vm._v(_vm._s(_vm.$t("Kyc.Under-Review"))),
                ]),
                _c("div", { staticClass: "under-review-desc" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("Kyc.Verification-Under-Review")) + " "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "capture-btn" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          to: {
                            name: "home",
                            params: { lang: this.lang || undefined },
                          },
                          variant: "primary",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Kyc.Go-Home")) + " ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/kyc/StartKYC.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import assets_rashi_coin_verification_1_svg from '@/assets/rashi-coin/verification-1.svg';
import assets_rashi_coin_verification_2_svg from '@/assets/rashi-coin/verification-2.svg';
import layouts_components_Stepper_vue from '@/layouts/components/Stepper.vue';
import utils_hideEmail from '@/utils/hideEmail';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
import * as vuex from 'vuex';
import assets_rashi_coin_under_review_svg from '@/assets/rashi-coin/under-review.svg';
import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











export default ({
  render,
  staticRenderFns,
  components: {
    BCard: bootstrapvue["BCard"],
    BAvatar: bootstrapvue["BAvatar"],
    BButton: bootstrapvue["BButton"],
    BCard: bootstrapvue["BCard"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    VerificationI: assets_rashi_coin_verification_1_svg,
    VerificationII: assets_rashi_coin_verification_2_svg,
    Stepper: layouts_components_Stepper_vue,
    UnderReview: assets_rashi_coin_under_review_svg,
    Errors: layouts_components_Errors_vue
  },
  data() {
    return {
      updateState: 0,
      steps: [{
        title: this.$t("Kyc.Identification-Document"),
        text: this.$t("Kyc.Process-Info-1")
        // status: "success"
      }, {
        title: this.$t("Kyc.Income-Tax-Document"),
        text: this.$t("Kyc.Process-Info-2")
        // status: "pending"
      }, {
        title: this.$t("Kyc.Selfie"),
        text: this.$t("Kyc.Process-Info-3")
        // status: "failed"
      }],
      userEmail: "",
      firstName: "",
      isLoading: false,
      lang: this.$route.params.lang,
      buttonTxtFlag: null,
      disapprovedRemark: "",
      buttonDisabled: true,
      buttonText: this.$t("Kyc.Start-KYC"),
      status: ""
    };
  },
  computed: {
    ...vuex.mapState("user", ["user"])
  },
  watch: {
    user(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getUserEmail(newValue);
      }
    }
  },
  mounted() {
    this.getUserEmail();
    this.getKYCDetail();
  },
  methods: {
    ...vuex.mapMutations("user", ["setUser"]),
    refreshKycStatus() {
      this.getKYCDetail();
    },
    async getUserEmail() {
      if (this.user.email && this.user.email.length) {
        this.userEmail = await utils_hideEmail.apply(this, [`${this.user.email}`]);
        this.firstName = this.user.email[0];
      } else {
        this.userEmail = "";
        this.firstName = "";
      }
    },
    stepStatus(stepNumber) {
      return this.steps[stepNumber].status;
    },
    updateStepStatus(stepNumber, newStatus) {
      this.$set(this.steps, stepNumber, {
        ...this.steps[stepNumber],
        status: newStatus
      });
    },
    async getKYCDetail() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: "kyc/details"
        }, {}, {
          isLoading: true
        });
        const details = (res && (res.verificationDetails || res.details)) || res;
        if (details && details.status) {
          const fullName = details.info && details.info.identification && details.info.identification.fullName;
          this.setUser({
            ...this.user,
            name: fullName || this.user.name,
            verificationStatus: details.status
          });
        }
        if (details && details.status === "DISAPPROVED") {
          this.buttonDisabled = true;
          this.disapprovedRemark = details.remark || "";
        } else {
          this.buttonDisabled = false;
          this.disapprovedRemark = "";
        }
        this.status = (details && details.status) || "";
        if (details && details.info) {
          this.buttonTxtFlag = null;
          const processStep = (stepIndex, verificationType) => {
            const verificationInfo = details.info[verificationType];
            if (verificationInfo) {
              if (!this.buttonTxtFlag) {
                this.buttonTxtFlag = false;
              }
              const stepStatus = verificationInfo.verificationStatus || (details.status === "APPROVED" ? "APPROVED" : "");
              if (stepStatus === "APPROVED") {
                this.steps[stepIndex].status = "success";
              } else if (stepStatus === "SUBMITTED" || stepStatus === "PENDING") {
                this.steps[stepIndex].status = "pending";
              } else if (stepStatus === "REJECTED") {
                this.steps[stepIndex].status = "failed";
                this.buttonTxtFlag = true;
              } else {
                this.steps[stepIndex].status = stepStatus;
              }
              this.steps[stepIndex].remark = verificationInfo.remark;
            } else if (details.status === "APPROVED") {
              this.steps[stepIndex].status = "success";
            }
          };
          processStep(0, "identification");
          processStep(1, "pan");
          processStep(2, "selfi");
          if (this.buttonTxtFlag === false) {
            this.buttonText = this.$t("Kyc.Continue");
          } else if (this.buttonTxtFlag) {
            this.buttonText = this.$t("Kyc.Re-Submit");
          } else {
            this.buttonText = this.$t("Kyc.Start-KYC");
          }
          this.updateState++;
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res && res.error && res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      } finally {
        this.isLoading = false;
      }
    }
  }
});

//# sourceURL=webpack:///./src/views/kyc/StartKYC.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.min-hight-80vh {
  min-height: 80vh;
}
</style>
